<template>
    <div>
        <div v-if="examId != null">
            <div class="row mb-3">

                <div class="col-md-10 d-flex align-items-center">
                    <b-button variant="outline-secondary" class="btn-sm mr-3" @click="backPage"><i
                            class="ri-arrow-left-line" style="font-size: 30px;"></i>
                    </b-button>
                    <span class="exam mr-2">{{ $t('grade_entry') }}</span>|<span class="course mx-2">
                        {{ courseName }}
                    </span>-<span class="exam-type ml-2">
                        {{ examTypeText }} {{ exam_date ? `- ${this.$moment(exam_date).format("DD/MM/YYYY")}` : '' }}
                    </span>
                </div>
                <div class="col-md-2 d-flex justify-content-end">
                    <b-button-group v-if="!editStatus">
                        <b-dropdown right :text="$t('menu')" variant="success">
                            <b-dropdown-item @click="editStatus = !editStatus" v-if="checkPermission('examquestion_scoreentrystore')">
                                <i class="ri-edit-line mr-1"></i>{{ $t('edit') }}
                            </b-dropdown-item>
                            <b-dropdown-item @click="downloadTemplate" v-if="checkPermission('examquestion_scoretemplateexcelexport')">
                                <i class="ri-file-download-line mr-1"></i>{{ $t('download_excel_template') }}
                            </b-dropdown-item>
                            <b-dropdown-item @click="uploadExcel" v-if="checkPermission('examquestion_scoretemplateexcelimport')">
                                <i class="ri-file-upload-line mr-1"></i>{{ $t('import') }}
                            </b-dropdown-item>
                        </b-dropdown>
                    </b-button-group>
                    <b-button class="mt-3 mt-md-0"
                              variant="success"
                              @click="save"
                              v-else><i class="ri-add-line mr-1"></i>
                        {{ $t('save') }}
                    </b-button>
                </div>
            </div>
        </div>
        <div>
            <b-table :empty-filtered-text="this.$t('table_not_found')"
                     :empty-text="this.$t('table_is_empty')" bordered striped responsive
                     :items="studentsArr" :fields="questionsArr"
                     class="mb-5 table-dropdown no-scrollbar border rounded">
                <template v-for="(field, index) in questionsArr" #[`cell(${field.key})`]="data">
                    <div v-if="index > 1" :key="field.key">
                        <div class="row">
                            <div class="col-md-6 mt-2">
                                <b-form-checkbox v-model="data.item[field.key].attended" :disabled="!editStatus">
                                    <span>{{ $t('attended_to_exam') }}</span>
                                </b-form-checkbox>
                            </div>
                            <div class="col-md-6">
                                <b-form-input :disabled="!editStatus" v-model="data.item[field.key].score" type="number" />
                            </div>
                        </div>

                    </div>
                    <div v-else :key="field.key">
                        {{ data.value }}
                    </div>
                </template>
            </b-table>
            <CommonModal ref="createForm" size="lg" :onHideOnlyX="true" @bHideModalHeaderClose="formClear()">
                <template v-slot:CommonModalTitle>
                    {{ $t('import') }}
                </template>
                <template v-slot:CommonModalContent>
                    <update-form v-if="formProgress" :courseId="courseId" :examExamId="examExamId" :updateData="updateData" @successForm="successForm" />
                </template>
            </CommonModal>
        </div>
    </div>
</template>
<script >
//Pages
import Import from "./Import.vue"
//Services
import ExamQuestionsService from "@/services/ExamQuestionsService"

export default {
    components: {
        UpdateForm: Import
    },
    props: {
        examId: {
            type: Number
        },
        examExamId: {
          type: Number
        },
        examTypeText: {
            type: String
        },
        courseName: {
            type: String
        },
        section_id: {
            type: Number
        },
        numberOfExams: {
            type: Number
        },
        threshold_value: {
            type: Number
        },
        courseId: {
            type: Number,
        }
    },
    data() {
        return {
            showExam: false,
            form: {},
            exam_id: null,
            exam_date: null,
            is_finalized: false,
            published_at : null,
            errors: [],
            students: [],
            formProgress: null,
            formId: null,
            updateData: null,
            studentsArr: [],
            questionsArr: [
                {
                    key: "student_number",
                    label: this.toUpperCase("student_number"),
                },
                {
                    key: "name",
                    label: this.toUpperCase("name_surname"),
                    formatter: (value, key, item) => {
                        return item.name + " " + item.surname;
                    },
                },
            ],
            editStatus: false,
        }
    },
    watch: {
        examId: {
            handler(newValue) {
                this.getRows(newValue)
            }
        }
    },
    created() {
        this.getRows(this.examExamId)
    },
    methods: {
        formClear() {
            this.formProgress = null
            this.updateData = null
        },

        getRows(value) {
            this.studentsArr = []
                this.questionsArr = [
                {
                    key: "student_number",
                    label: this.toUpperCase("student_number"),
                },
                {
                    key: "name",
                    label: this.toUpperCase("name_surname"),
                    formatter: (value, key, item) => {
                        return item.name + " " + item.surname;
                    },
                },
            ]

            ExamQuestionsService.getStudentsAndScores(value).then(response => {
                let data = response.data.data
                data.questions.forEach(question => {
                    this.questionsArr.push({
                        key: question.id.toString(),
                        label: question.question
                    })
                })

                data.students.forEach(student => {
                    let scores = {}
                    student.question_scores.forEach(score => {
                        scores[score.exam_question_id.toString()] = {
                            score: score.score,
                            attended: score.attended ? false : true,
                        }
                    })
                    this.studentsArr.push({
                        student_number: student.student_number,
                        name: student.name,
                        surname: student.surname,
                        student_program_id: student.student_program_id,
                        ...scores,
                    })
                })
            }).catch(e => {
                this.showErrors(e, null)
            })
        },

        formDelete(id) {
            this.$swal.fire({
                text: this.$t('are_you_sure_to_delete'),
                showCancelButton: true,
                confirmButtonText: this.$t('yes'),
                cancelButtonText: this.$t('no'),
            }).then((result) => {
                if (result.isConfirmed) {
                    ExamQuestionsService.del(id).then(response => {
                        this.$toast.success(this.$t('api.' + response.data.message))
                        this.getRows(this.examExamId)
                        this.formClear()
                    }).catch(error => {
                        this.$toast.error(this.$t('api.' + error.data.message))
                    })
                }
            })
        },
        addQuestions() {
            this.formProgress = 'create'
            this.$refs.createForm.$refs.commonModal.show()
        },
        successForm() {
            this.formClear()
            this.formProgress = null
            this.$refs.createForm.$refs.commonModal.hide()
            this.getRows(this.examExamId)
        },
        updateExams(row) {
            this.updateData = row
            this.formProgress = 'update'
            this.$refs.createForm.$refs.commonModal.show()
        },
        successUpdateForm() {
            this.formClear()
            this.$refs.updateForm.$refs.commonModal.hide();
            this.getRows(this.examId)
        },
        backPage() {
            this.$emit('tableStatusUpdate', 'exam')
        },

        save(){
            let formData = {
                exam_id: parseInt(this.examExamId),
                students: []
            }
            this.studentsArr.forEach(student => {
                let scores = []
                this.questionsArr.forEach((question, index) => {
                    if(index > 1){
                        scores.push({
                            exam_question_id: parseInt(question.key),
                            score: student[question.key].score,
                            attended: student[question.key].attended ? 0 : 1
                        })
                    }
                })
                formData.students.push({
                    student_program_id: student.student_program_id,
                    question_scores: scores,
                })
            })
            ExamQuestionsService.updateStudentScores(formData, this.examExamId).then(response => {
                this.$toast.success(response.data.message)
                this.editStatus = false
                this.getRows(this.examExamId)
            }).catch(e => {
                this.showErrors(e, null)
            })
        },

        downloadTemplate(){
            ExamQuestionsService.downloadTemplate(this.examExamId).then(response => {
                this._downloadFile(response, this.$t('grade_entry')+'-'+this.courseName+'-'+this.examTypeText+'.xlsx')
            }).catch(e => {
                this.showErrors(e, null)
            })
        },

        uploadExcel(){
            this.formProgress = 'create'
            this.$refs.createForm.$refs.commonModal.show()
        }
    },
}
</script>
<style>
.table-custom-btn {
    width: 100%;
    min-height: 40px;
}

.exam {
    font-size: 20px;
    color: black;
}

.course {
    font-size: 16px;
}

.exam-type {
    font-size: 16px;
}

.icon {
    font-size: 16px;
}
</style>
